import React from "react";
import { Reducer, TenantUserStateType, TenantUserDispatch } from "./reducer";

export const TenantUserStateContext = React.createContext<TenantUserStateType>({
  data: [],
});
export const TenantUserDispatchContext = React.createContext<
  TenantUserDispatch | undefined
>(undefined);

interface TenantUserProviderProps {}

type TenantUserProviderPropsType =
  React.PropsWithChildren<TenantUserProviderProps>;

export const TenantUserProvider: React.FC<TenantUserProviderPropsType> = ({
  children,
}: TenantUserProviderPropsType) => {
  const [state, dispatch] = React.useReducer(Reducer, {
    data: [],
  });
  return (
    <TenantUserDispatchContext.Provider value={dispatch}>
      <TenantUserStateContext.Provider value={state}>
        {children}
      </TenantUserStateContext.Provider>
    </TenantUserDispatchContext.Provider>
  );
};

export const useTenantUserState = () => {
  const state = React.useContext(TenantUserStateContext);
  return state;
};

export const useTenantUserDispatch = () => {
  const dispatch = React.useContext(TenantUserDispatchContext);
  return dispatch;
};
